export enum NavigationStep {
  AssetType = "AssetType",
  Shipments = "Shipments",
  BusinessExpense = "BusinessExpense",
  BusinessImprovement = "BusinessImprovement",
  Results = "Results",
}
